export const WARNING_BAR = {
  mode: {
    hide: 'Hide',
    show: 'Show',
  },
  type: {
    error: 'Error',
    connectionError: 'ConnectionError',
    agentError: 'AgentError',
    permissionError: 'PermissionError',
    communicationError: 'CommunicationError',
    info: 'Info',
    success: 'Success',
    successServicingCancel: 'SuccessServicingCancel',
    warning: 'Warning',
    recalculatePrinceIsMissingError: 'RecalculatePrinceIsMissingError',
  },
} as const
